import React, { useContext, useEffect } from "react";
import ErrorResources from "../../../Components/ErrorResources";
import DataContext from "../../../Context";
import LocalizationContext from "../../../Localization/LanguageContext";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import { IPolicy } from "../../../Models/PolicyInfo";
import { LandingPage } from "../../../Components/LandingPage/LandingPage";

const Error = () => {
  const { errorPageMsg, setAppHasState } = useContext(DataContext) as IPolicy;
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  useEffect(() => {
    setAppHasState(false);
  }, []);

  return (
      <LandingPage
        headingProps={{
          size: "xl",
          center: true,
          children: getValue('Error', 'TitleError')
          }}
        subtitleProps={{
          size: "lg",
          center: true,
          children: getValue('Error', 'TitleSub')
        }}
        description={
          <>
            <div className="error-resources">
              {getValue('Error', 'ErrorDetailPrefix')}
              <i>{getValue('Error', 'ErrorDetailSuffix')}</i>
            </div>
            <ErrorResources />
          </>
        }
      />
  );
};

export default Error;
